<template>
  <div>
    <form autocomplete="off" @submit.prevent="savePartner">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $t('Partner') }}</h4>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col md="6">
            <label>{{ $t('Name') }}</label>
            <b-form-input :trim="true" autocomplete="off" required v-model="name" />
          </b-col>
          <b-col md="6">
            <label>{{ $t('Brand') }}</label>
            <brandSelectorUnique :modelValue="idBrand" @onChange="setBrand" />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="4" v-if="!isComponentPage">
            <label>{{ $t('Level') }}</label>
            <b-form-select v-model="level">
              <option v-text="$t('Level 1')" :value="1" />
              <option v-text="$t('Level 2')" :value="2" />
              <option v-text="$t('Level 3')" :value="3" />
            </b-form-select>
          </b-col>
          <b-col md="4">
            <label>{{ $t('Percentage') }} (%)</label>
            <b-form-input type="number" autocomplete="off" step="0.01" required v-model="percentage" />
          </b-col>
          <b-col md="4">
            <label>
              {{ $t('Calculation') }}
              <i
                class="text-secondary mdi mdi-information"
                :title="$t('Utilize as palavras reservadas')"
                v-b-popover.hover="`${$utils.expressionKeywords.join(', ')}`"
              />
            </label>
            <b-form-input :trim="true" autocomplete="off" :required="!isCpa" v-model="calculation" />
          </b-col>
          <b-col md="4">
            <label>
              {{ $t('Reward Deduction') }}
              <i
                class="text-secondary mdi mdi-information"
                :title="$t('Reward Deduction')"
                v-b-popover.hover="$t('Activate reward deduction by partner level')"
              />
            </label>
            <b-form-select v-model="reward_deduction">
              <option v-text="$t('Enabled')" :value="true" />
              <option v-text="$t('Disabled')" :value="false" />
            </b-form-select>
          </b-col>
        </b-row>
      </b-card>
      <b-row>
        <div>
          <button type="submit" class="btn btn-primary m-1" :disabled="$store.state.isLoading" v-if="!partner">
            {{ $t('Create') }}
          </button>
          <button v-if="!isComponentPage" type="button" class="btn btn-secondary m-1" @click="$router.back()">
            {{ $t('Back') }}
          </button>
        </div>
      </b-row>
    </form>
  </div>
</template>

<script>
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';

export default {
  props: ['isComponent', 'partnerLevel', 'partner'],
  emits: ['onSave'],
  components: {
    brandSelectorUnique
  },
  data() {
    return {
      name: '',
      level: null,
      idBrand: null,
      percentage: 0,
      reward_deduction: false,
      partnerId: null,
      calculation: ''
    };
  },
  mounted() {
    if (this.$route?.params?.id) {
      this.partnerId = this.$route.params.id;
    }

    if (this.partner) {
      this.partnerId = this.partner;
      this.getPartner();
    }

    if (this.isComponentPage) return;

    if (this.partnerId) {
      this.getPartner();
    }
  },
  computed: {
    isComponentPage() {
      return this.isComponent == true;
    }
  },
  methods: {
    savePartner() {
      if (this.partner) {
        this.updatePartner();
        return;
      }
      if (this.isComponentPage) {
        this.createPartner();
        return;
      }
      if (this.partnerId) {
        this.updatePartner();
      } else {
        this.createPartner();
      }
    },
    getPartner() {
      const partnerId = this.partnerId;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/partner/${partnerId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let partner = res.data;

          this.name = partner.name;
          this.level = partner.level;
          this.idBrand = partner.id_brand;
          this.percentage = parseFloat(partner?.reward?.percentage || 0) * 100;
          this.calculation = partner?.reward?.calculation || '';
          this.reward_deduction = partner?.reward_deduction || false;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createPartner() {
      if (!this.validatePartner()) return;
      let partner = {
        name: this.name,
        level: this.level,
        idBrand: this.idBrand,
        reward_deduction: this?.reward_deduction || false,
        reward: {
          percentage: parseFloat(this?.percentage || 0) / 100,
          calculation: this?.calculation || ''
        }
      };

      if (this.isComponentPage) {
        partner.level = this.partnerLevel;
      }

      this.$store.commit('SET_LOADING', true);

      this.$api
        .post('api/partner', partner)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          if (this.isComponentPage) {
            this.$emit('onSave', {
              ...partner,
              id: parseInt(res.data.id),
              token: res.data.token
            });
            return;
          }

          this.$router.push({
            name: 'partnerList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create partner error')
          });
        });
    },
    updatePartner() {
      if (!this.validatePartner()) return;
      let partnerId = this.partnerId;
      let partner = {
        name: this.name,
        level: this.level,
        idBrand: this.idBrand,
        reward_deduction: this?.reward_deduction || false,
        reward: {
          percentage: parseFloat(this?.percentage || 0) / 100,
          calculation: this?.calculation || ''
        }
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/partner/${partnerId}`, partner)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          if (this.isComponentPage) {
            this.$emit('onSave', {
              ...partner,
              id: partnerId
            });
            return;
          }
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'partnerList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update partner error')
          });
        });
    },
    setBrand(brand = null) {
      this.idBrand = brand;
    },
    validatePartner() {
      if (!this.idBrand) {
        this.$customAlert({
          msg: this.$t('Invalid brand'),
          type: 'error'
        });
        return false;
      }
      if (this.calculation && !this.$utils.expressionValidade(this.calculation)) {
        this.$customAlert({
          msg: this.$t('Invalid calculation expression'),
          type: 'error'
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
.popover {
  z-index: 1060;
}
</style>
